import * as React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import type { CustomListProps } from '@wartek-id/select'
import type { OptionItem } from '@wartek-id/select'
import { CustomSelect } from '@wartek-id/select'

import { DEFAULT_YEAR_RANGE_DIFFERENCE } from 'app/KinerjaShared/components/DatePicker/constants'
import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'

import type { CalendarState } from '@react-stately/calendar'

export interface CalendarYearDropdownProps {
  state: CalendarState
  minYear?: number | string
  maxYear?: number | string
}

function CustomList(props: CustomListProps) {
  return (
    <div
      data-testid="option-year"
      className={clsx(props.active && 'calendarDropdownActiveItem')}
    >
      <Text>{props.item}</Text>
    </div>
  )
}

function CustomDisplayValue(props: Pick<CustomListProps, 'item'>) {
  return <span data-testid="selected-year">{props.item}</span>
}

export function CalendarYearDropdown({
  state,
  minYear,
  maxYear,
}: CalendarYearDropdownProps) {
  const years: number[] = []

  const yearStartDifference = minYear
    ? state.focusedDate.year - Number(minYear)
    : DEFAULT_YEAR_RANGE_DIFFERENCE
  const yearEndDifference = maxYear
    ? Number(maxYear) - state.focusedDate.year
    : DEFAULT_YEAR_RANGE_DIFFERENCE

  for (let i = -yearStartDifference; i <= yearEndDifference; i++) {
    const date = state.focusedDate.add({ years: i })
    years.push(date.year)
  }

  const onChangeYear = (year: string | OptionItem) => {
    state.setFocusedDate(state.focusedDate.set({ year: Number(year) }))
  }

  return (
    <CustomSelect
      className={styles.dropdownCalendar}
      options={years.map((year) => year.toString())}
      customList={CustomList}
      customDisplayValue={CustomDisplayValue}
      value={state.focusedDate.year.toString()}
      onChange={onChangeYear}
    />
  )
}
